import { useEffect, useState } from "react";
import { CreditCard, Loader2, Zap, Crown } from "lucide-react";
import api, { apiErr } from "../lib/api";
import { Card } from "./ui-bits";
import { toast } from "sonner";

/**
 * Histórico de pagos del usuario: suscripciones y compras sueltas de créditos.
 *
 * Solo se muestran los PAGADOS. La transacción se crea al abrir el checkout, así que la
 * colección guarda también intentos abandonados; enseñarlos aquí sería decirle al usuario que
 * gastó un dinero que nunca salió de su cuenta.
 */
export default function Pagos() {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/payments/historial").then((r) => setD(r.data)).catch((e) => toast.error(apiErr(e)));
  }, []);

  if (!d) {
    return (
      <Card className="p-6 flex justify-center">
        <Loader2 className="animate-spin text-blue-600" size={28} />
      </Card>
    );
  }

  const fecha = (f) => {
    try { return new Date(f).toLocaleDateString(undefined, { dateStyle: "medium" }); }
    catch { return String(f || "").substring(0, 10); }
  };

  return (
    <Card className="p-6 space-y-4" data-testid="pagos-usuario">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <h3 className="text-xl font-semibold text-slate-900 flex items-center gap-2">
          <CreditCard size={22} className="text-blue-600" /> Tus pagos
        </h3>
        {d.total > 0 && (
          <div className="text-right">
            <div className="text-2xl font-extrabold text-slate-900 tabular-nums">{d.total} €</div>
            <div className="text-sm text-slate-500">total pagado</div>
          </div>
        )}
      </div>

      {d.pagos?.length ? (
        <div className="space-y-2">
          {d.pagos.map((p, i) => (
            <div key={i} className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-slate-100 pb-2">
              <span className={`shrink-0 grid place-items-center h-8 w-8 rounded-lg ${
                p.tipo === "recarga" ? "bg-amber-100 text-amber-600" : "bg-blue-100 text-blue-600"}`}>
                {p.tipo === "recarga" ? <Zap size={16} /> : <Crown size={16} />}
              </span>
              <div className="min-w-0">
                <div className="text-base font-semibold text-slate-900">
                  {p.concepto}
                  {p.periodo === "annual" && <span className="ml-2 text-sm font-normal text-slate-500">anual</span>}
                  {/* Un pago en modo test no es dinero real: sin esta marca, alguien podría
                      cuadrar sus cuentas con transacciones de prueba. */}
                  {p.prueba && (
                    <span className="ml-2 rounded bg-slate-200 px-1.5 py-0.5 text-xs font-bold text-slate-600">prueba</span>
                  )}
                </div>
                <div className="text-sm text-slate-500">{fecha(p.fecha)}</div>
              </div>
              <span className="ml-auto text-base font-bold text-slate-900 tabular-nums">
                {p.importe} {p.moneda === "EUR" ? "€" : p.moneda}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-base text-slate-500">Todavía no has hecho ningún pago.</p>
      )}
    </Card>
  );
}
